<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * creates a widget for the to do list, intended for placement in the header
    *
    * @since 20200522
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span>            
        <a id="toDoDropdown" href="#" class="nav-link dropdown-toggle text-dark mr-3" title="To Do" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-bell fa-lg pr-1 icon-custom" ></i>
            <span class="badge badge-pill badge-secondary align-top">
                <i v-if="refreshing" class="fas fa-sync fa-spin"></i>
                <span v-else>{{list_items.length}}</span>
            </span>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="toDoDropdown">
          <!--   <i v-if="refreshing" class="fas fa-sync fa-spin"></i> -->
            <ul ><!-- v-else -->
                <li v-for="item in list_items" :key="item.text">
                    <a :href="item.route">{{item.text}}</a>
                </li>
            </ul>
        </div>
    </span>
</template>

<script>
    export default{
        props: {
            to_do_route: {
                type: String,
                default: ''
            },
            shouldRefresh: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            if(this.$parent.$refs.to_do_list_dash !== undefined){
            } else {
                if(this.shouldRefresh || !localStorage.getItem('to_do_list_' + this.to_do_route) || localStorage.getItem('to_do_list_refreshing' + this.to_do_route)){
                    this.refresh();
                }
            }
            if (localStorage.getItem('to_do_list_' + this.to_do_route)) {
                try {
                    this.data = JSON.parse(localStorage.getItem('to_do_list_' + this.to_do_route));
                    this.refreshing = false;
                } catch(e) {
                    localStorage.removeItem('to_do_list_' + this.to_do_route);
                }
            }
        },
        data() {
            return {
                //whether or not it is refreshing
                refreshing: false,
                //whether or not an error occured
                error_occured: false,
                //the to do list data,
                data: {},
                //a list of other widgets that need refreshing when the todo list is acquired
                registeredSingles: [],
                progress: 0,
                total: 0,
                jobRoute: '',
            }
        },
        computed: {
            list_items: function(){
                var arr = [];
                for(var key in this.data) {
                    for(var i=0; i<this.data[key].box_items.length; i++){
                        if(this.data[key].box_items[i].value > 0){
                            arr.push(this.data[key].box_items[i]);
                        }
                    }
                    for(var i=0; i<this.data[key].items.length; i++){
                        if(this.data[key].items[i].value > 0){
                            arr.push(this.data[key].items[i]);
                        }
                    }
                    
                }
                return arr;
            },
            data_content: function(){
                if(this.refreshing){
                    return '<i class="fas fa-sync fa-spin"></i>'
                } else {
                    var str = '<ul>';
                    for(var i=0; i<this.list_items.length; i++){
                        str = str + '<li>' + this.list_items[i].text + '</li>';
                    }
                    str = str + '</ul>';
                    return str;
                }
            }
        },
        methods: {
            /**
             * loads in to do list
             * 
             * @param boolean reload if true, it reloads the cache, otherwise gets from cache
             * 
             * @return Array an array of attendance
             */
            load_to_do_list: function (reload=false) {
                this.$reportJobs.push({
                    toDoListJob: true,
                    object: this,
                    params: { 
                        reload: reload,
                    }
                });
            },
            setJobProgress: function(data){
                this.progress = data.progress;
                this.total = data.total;
                this.jobRoute = data.jobRoute;
            },
            setJobComplete: function(data){
                this.data = data.graphData;
                localStorage.setItem('to_do_list_' + this.to_do_route, JSON.stringify(data.graphData));
                this.refreshing = false;
                localStorage.removeItem('to_do_list_refreshing' + this.to_do_route);
                for(var i=0; i<this.registeredSingles.length; i++){
                    this.registeredSingles[i].data = this.data;
                }
            },
            setJobError: function(data){
                this.errorOccurred = true;
                console.log('An error occurred loading the to do list');
                if(data.error !== undefined){
                    console.log(data.error);
                }
                this.refreshing = false;
                this.jobRoute = '';
            },
            /**
             * refreshes the to do list from the url
             * 
             * @param boolean reload if true, it reloads the cache, otherwise gets from cache
             */
            refresh: function(reload=false){
                this.refreshing = true;
                localStorage.setItem('to_do_list_refreshing' + this.to_do_route, true);
                this.load_to_do_list(reload);
            },
        }
    }
</script>